var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('b-row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', {
    staticClass: "custom-font mb-1"
  }, [_c('b', [_vm._v("Due Invoice Summary [Last 30 Days]")])]), _c('div', {
    staticClass: "button-style"
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 mr-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.goInvoice
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "ClipboardIcon"
    }
  })], 1)], 1)]), _c('b-table', {
    attrs: {
      "responsive": "sm",
      "fields": _vm.fields,
      "items": _vm.items,
      "sticky-header": "",
      "height": "300px"
    },
    scopedSlots: _vm._u([{
      key: "cell(invoice_no)",
      fn: function fn(data) {
        var _data$item3;
        return [_c('span', {
          staticClass: "font-weight-bold cursor-pointer text-primary",
          on: {
            "click": function click($event) {
              var _data$item, _data$item$data, _data$item2, _data$item2$data;
              return _vm.moveToDetails((_data$item = data.item) === null || _data$item === void 0 ? void 0 : (_data$item$data = _data$item.data) === null || _data$item$data === void 0 ? void 0 : _data$item$data.id, (_data$item2 = data.item) === null || _data$item2 === void 0 ? void 0 : (_data$item2$data = _data$item2.data) === null || _data$item2$data === void 0 ? void 0 : _data$item2$data.milestone_id);
            }
          }
        }, [_vm._v(_vm._s((_data$item3 = data.item) === null || _data$item3 === void 0 ? void 0 : _data$item3.invoice_no))])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }